import { createStore, combineReducers, compose } from "redux"

import generalReducer from "./general"

const reducers = combineReducers({
  general: generalReducer,
})

let composeEnhancers

// Redux Deverloper Tools 비활성화
if (process.env.NODE_ENV === "development") composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
else composeEnhancers = compose

// React Developer Tools 비활성화
if (process.env.NODE_ENV === "production" && typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object")
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {}

const store = createStore(reducers, /* preloadedState, */ composeEnhancers())

export default store
